// Ejemplos con pantallas LCD de caracteres.
import { part, wires, UNO } from './helpers.js';

export const EXAMPLES = [
  {
    id: 'lcd-i2c',
    category: 'Pantallas',
    name: 'LCD 16×2 I²C',
    description: 'Texto, un carácter propio (corazón) y un contador en una LCD con adaptador I²C: solo 4 cables.',
    project: {
      name: 'LCD I2C',
      files: {
        'sketch.ino': `// LCD 16x2 con adaptador I2C (PCF8574, dirección 0x27).
// SDA va a A4 y SCL a A5. Librería: LiquidCrystal_I2C.
#include <Wire.h>
#include <LiquidCrystal_I2C.h>

LiquidCrystal_I2C lcd(0x27, 16, 2);

byte corazon[8] = {
  0b00000,
  0b01010,
  0b11111,
  0b11111,
  0b01110,
  0b00100,
  0b00000,
  0b00000,
};

void setup() {
  lcd.init();
  lcd.backlight();
  lcd.createChar(0, corazon);
  lcd.setCursor(0, 0);
  lcd.print("Hola Arduino 3D");
  lcd.setCursor(0, 1);
  lcd.write(byte(0));
  lcd.print(" Segundos:");
}

void loop() {
  lcd.setCursor(12, 1);
  lcd.print(millis() / 1000);
  delay(200);
}
`,
      },
      parts: [UNO, part('lcd1', 'lcd-i2c', { size: '16x2', color: 'blue' }, { x: 12, z: 78, rot: 0 })],
      wires: wires([
        ['uno:GND.2', 'lcd1:GND', 'black'],
        ['uno:5V', 'lcd1:VCC', 'red'],
        ['uno:A4', 'lcd1:SDA', 'blue'],
        ['uno:A5', 'lcd1:SCL', 'yellow'],
      ]),
    },
  },
  {
    id: 'lcd-paralelo',
    category: 'Pantallas',
    name: 'LCD 16×2 en paralelo («Hola, mundo»)',
    description: 'El ejemplo clásico de LiquidCrystal en modo de 4 bits (RS=12, E=11, D4–D7 = 5, 4, 3, 2) con la alimentación en la protoboard.',
    project: {
      name: 'LCD paralelo',
      files: {
        'sketch.ino': `// LCD 16x2 en modo de 4 bits con la librería LiquidCrystal.
// RS=12, E=11, D4=5, D5=4, D6=3, D7=2. VSS, RW, V0 y K van a GND; VDD y A a 5 V.
#include <LiquidCrystal.h>

LiquidCrystal lcd(12, 11, 5, 4, 3, 2);

void setup() {
  lcd.begin(16, 2);
  lcd.print("Hola, mundo!");
}

void loop() {
  lcd.setCursor(0, 1);
  lcd.print("Tiempo: ");
  lcd.print(millis() / 1000);
  lcd.print(" s");
  delay(250);
}
`,
      },
      parts: [
        UNO,
        { id: 'bb1', type: 'breadboard', x: 0, z: 72, rot: 0, props: { size: 'half' } },
        part('lcd1', 'lcd', { size: '16x2', color: 'green' }, { x: 0, z: 142, rot: 0 }),
      ],
      wires: wires([
        ['uno:5V', 'bb1:tp13', 'red'],
        ['uno:GND.2', 'bb1:tn14', 'black'],
        ['bb1:tp1', 'bb1:bp1', 'red'],
        ['bb1:tn1', 'bb1:bn1', 'black'],
        ['lcd1:VSS', 'bb1:bn2', 'black'],
        ['lcd1:VDD', 'bb1:bp3', 'red'],
        ['lcd1:V0', 'bb1:bn5', 'black'],
        ['lcd1:RW', 'bb1:bn6', 'black'],
        ['lcd1:A', 'bb1:bp14', 'red'],
        ['lcd1:K', 'bb1:bn15', 'black'],
        ['uno:12', 'lcd1:RS', 'orange'],
        ['uno:11', 'lcd1:E', 'yellow'],
        ['uno:5', 'lcd1:D4', 'green'],
        ['uno:4', 'lcd1:D5', 'blue'],
        ['uno:3', 'lcd1:D6', 'purple'],
        ['uno:2', 'lcd1:D7', 'gray'],
      ]),
    },
  },
  {
    id: 'lcd-2004',
    category: 'Pantallas',
    name: 'LCD 20×4: reloj y barra de progreso',
    description: 'Una LCD de 4 líneas con caracteres propios que dibujan una barra de progreso suave.',
    project: {
      name: 'LCD 20x4',
      files: {
        'sketch.ino': `// LCD 20x4 I2C: reloj desde el arranque y una barra de progreso con caracteres propios.
#include <Wire.h>
#include <LiquidCrystal_I2C.h>

LiquidCrystal_I2C lcd(0x27, 20, 4);

// Bloques de 1 a 5 columnas para la barra
void crearBloques() {
  for (int n = 1; n <= 5; n++) {
    byte c[8];
    byte fila = 0;
    for (int i = 0; i < n; i++) fila |= 1 << (4 - i);
    for (int i = 0; i < 8; i++) c[i] = fila;
    lcd.createChar(n, c);
  }
}

void barra(int fila, int valor) {   // valor de 0 a 100
  int pasos = map(valor, 0, 100, 0, 20 * 5);
  lcd.setCursor(0, fila);
  for (int i = 0; i < 20; i++) {
    int resto = pasos - i * 5;
    if (resto >= 5) lcd.write(byte(5));
    else if (resto > 0) lcd.write(byte(resto));
    else lcd.print(' ');
  }
}

void setup() {
  lcd.init();
  lcd.backlight();
  crearBloques();
  lcd.setCursor(3, 0);
  lcd.print("Arduino 3D");
}

void loop() {
  unsigned long s = millis() / 1000;
  char texto[21];
  snprintf(texto, sizeof(texto), "Encendido %02lu:%02lu:%02lu", s / 3600, (s / 60) % 60, s % 60);
  lcd.setCursor(0, 1);
  lcd.print(texto);
  int p = (millis() / 50) % 101;
  lcd.setCursor(0, 2);
  lcd.print("Progreso: ");
  lcd.print(p);
  lcd.print("%  ");
  barra(3, p);
  delay(50);
}
`,
      },
      parts: [UNO, part('lcd1', 'lcd-i2c', { size: '20x4', color: 'blue' }, { x: 16, z: 92, rot: 0 })],
      wires: wires([
        ['uno:GND.2', 'lcd1:GND', 'black'],
        ['uno:5V', 'lcd1:VCC', 'red'],
        ['uno:A4', 'lcd1:SDA', 'blue'],
        ['uno:A5', 'lcd1:SCL', 'yellow'],
      ]),
    },
  },
];
